<ng-container *transloco="let t; read: TRANSLATION_SCOPE">
  @if (authFacade.error$ | async) {
    <rx-alert type="danger" [message]="t('error.activationError')" data-qa="test-auth-activate-error"></rx-alert>
  }
  <p class="mb-4">{{ t('header') }}</p>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
    <rx-input
      class="form-field"
      [label]="t('label.name')"
      [placeholder]="t('label.placeholder')"
      [errorMessage]="t(getFirstErrorMessage(form, 'name'))"
      [parentForm]="form"
      [name]="'name'"
      [placeholder]="t('label.name')"
      formControlName="name"
      rxMandatory
      data-qa="test-auth-activate-user-name-input"
    />
    <rx-applications-phone-number-input
      class="form-field"
      [prefixLabel]="t('phoneNumber.prefixLabel')"
      [prefixPlaceholder]="t('phoneNumber.prefixPlaceholder')"
      [phoneLabel]="t('phoneNumber.phoneLabel')"
      [errorMessage]="t(getFirstErrorMessage(form, 'phoneNumber'))"
      [filterNoResultMessage]="t('phoneNumber.filterNoResultMessage')"
      [phoneNumberControl]="phoneNumberControl"
      (phoneChange)="onPhoneChange($event)"
      data-qa="test-auth-activate-user-phone-input"
    />
    @if (!isSsoEnabled) {
      <rx-password-match-form
        class="form-field"
        [parentForm]="form"
        [passwordLabel]="t('label.password')"
        [passwordConfirmLabel]="t('label.passwordConfirm')"
        [passwordMissing]="t('error.passwordMissing')"
        [passwordNotEqual]="t('error.passwordNotEqual')"
        [passwordPattern]="t('error.passwordPattern')"
      ></rx-password-match-form>
      <rx-applications-password-policy />
    }
    <rx-applications-contact-instructions />
    <div class="d-flex justify-content-end mt-4">
      <rx-button
        buttonClass="primary"
        type="submit"
        [disabled]="form.invalid"
        data-qa="test-auth-activate-user-submit-button"
      >
        <span *ngIf="(authFacade.isLoading$ | async) === false; else isLoading"> {{ t('button.active') }}</span>
        <ng-template #isLoading>
          {{ t('button.loading') }}
        </ng-template>
      </rx-button>
    </div>
  </form>
</ng-container>
